const localStorageKeys = {
  token: 'token',
  authUser: 'authUser',
} as const

export { localStorageKeys }
